import { render, staticRenderFns } from "./MaterialsFormation.vue?vue&type=template&id=2e6cd774&scoped=true"
import script from "./MaterialsFormation.vue?vue&type=script&lang=js"
export * from "./MaterialsFormation.vue?vue&type=script&lang=js"
import style0 from "./MaterialsFormation.vue?vue&type=style&index=0&id=2e6cd774&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6cd774",
  null
  
)

export default component.exports